export default {
  common: {
    loginBottomText: {
      prompt: 'Already have an account?',
      linkText: 'Log In',
    },
    linkMultipleAccounts: {
      prompt: 'Want to link multiple accounts?',
      linkText: 'Learn More',
    },
  },
  alreadyRegistered: {
    pageTitle: 'Already Registered',
    headerTitle: 'Register New Account',
    title: "It looks like you're already registered",
    buttons: {
      primary: {
        title: 'Login',
      },
      text: {
        register: 'Register with a different email?',
        forgotPassword: 'Forgot password?',
      },
    },
  },
  confirmEmail: {
    pageTitle: 'Verify Email',
    headerTitle: 'Register New Account',
    title: "Let's confirm your {{{ emailQualifier }}}email",
    parentEmailQualifier: "parent's ",
    instructions: {
      base: 'We sent a message to {{#primaryColor}}{{#bold}}{{{ relevantEmail }}}{{/bold}}{{/primaryColor}}. To start earning rewards {{ tail }}.',
      useResponsibleEmailTail:
        'your parents need to confirm their email address',
      defaultTail: 'you need to confirm your email address',
    },
    bottomText: {
      prompt: "Didn't receive an email?",
      linkText: 'Resend the Email',
    },
    defaultRelevantEmail: 'your email',
    buttons: {
      primary: {
        title: 'Submit Code',
      },
    },
  },
  emailConfirmed: {
    pageTitle: 'Email Verified',
    headerTitle: 'Register New Account',
    title: {
      useResponsibleEmail: "Parent's Email Confirmed!",
      default: 'Email Confirmed!',
    },
    instructions: {
      useResponsibleEmail:
        "Your parent's email is ready for you to earn rewards.",
      default: 'Your email is ready for you to earn rewards.',
    },
    buttons: {
      primary: {
        title: 'Next',
      },
    },
  },
  linkPractice: {
    pageTitle: 'Link To A {{ practiceType }}',
    headerTitle: 'Register New Account',
    title: 'Enter 16 digit rewards number or temporary registration code',
    instructions: {
      generic: 'Enter your 16 digit rewards number or Membership Code below.',
      default: {
        top: '',
        bottom: '',
      },
    },
    buttons: {
      primary: {
        title: 'Continue',
      },
      secondary: {
        title: {
          generic: {
            full: "I Don't Have Either Of These",
            top: "I Don't Have",
            bottom: 'Either Of These',
          },
          default: 'I never received a number or code',
        },
      },
    },
    dividerText: 'or',
    defaultPracticeName: 'us',
    cardNumberInput: {
      label: 'Rewards Number or Temp Registration Code',
      helperText:
        'Tip: Older reward cards or printouts may label this as "username."',
    },
    businessCodeInput: {
      label: 'Membership Code',
      helperText:
        "The 7-10 digit code in the rewards program section of the business's website.",
    },
  },
  linkInvite: {
    pageTitle: 'Accept Invite',
    headerTitle: 'Register New Account',
  },
  linkBusinessCode: {
    pageTitle: 'Accept Invite',
    headerTitle: 'Register New Account',
  },
  tellUsMore: {
    pageTitle: 'Tell Us More',
    headerTitle: 'Register New Account',
    title: 'Tell us more about you',
    instructions: 'This helps us know how to give you the best experience',
    inputs: {
      relationship: {
        valueLabels: {
          friend: "I'm a friend of a member",
          parentOrGuardian: "I'm a parent/guardian of a member",
          member: "I'm a member",
          other: 'Other',
        },
        prompt: 'Select an option',
        fieldLabel: 'How did you hear about us?',
        errors: {
          blank: 'Relationship is required.',
        },
      },
      why: {
        valueLabels: {
          products: "I'm interested in products or services",
          family: 'To join a linked family',
          account: 'To access my account',
          other: 'Other',
        },
        prompt: 'Select an option',
        fieldLabel: 'Why are you registering?',
        errors: {
          blank: 'Registration Reason is required.',
        },
      },
      questionsOrComments: {
        label: 'Comments',
        errors: {
          blank: 'Comments are required.',
        },
      },
    },
    buttons: {
      primary: {
        title: 'Next',
      },
      secondary: {
        title: 'Back',
      },
    },
  },
  nameMismatch: {
    pageTitle: 'Name Mismatch',
    headerTitle: 'Register New Account',
    title: {
      template: 'Your name does not match {{ method }}',
      methods: {
        cardNumber: 'rewards number',
        tempRegCode: 'registration code',
        inviteCode: 'invite',
      },
    },
    instructions: {
      cardNumber:
        'The name associated with rewards number {{ cardNumber }} at {{{ practiceName }}} does not match the name you entered.',
      tempRegCode:
        'The name associated with temporary registration code {{ cardNumber }} at {{{ practiceName }}} does not match the name you entered.',
      inviteCode:
        'The name associated with this invite at {{{ practiceName }}} does not match the name you entered.',
    },
    buttons: {
      primary: {
        title: 'Try Again',
      },
      secondary: {
        title: 'Register Later',
      },
    },
  },
  noGenericRegistration: {
    pageTitle: 'Register New Account',
    headerTitle: 'Register New Account',
    title: 'No rewards number?',
    instructions: {
      top: 'To get rewarded, you need to register with a business. Registering with a company will unlock contests, games, and more.',
      bottom:
        'If you already have a profile with the business, contact them to get a rewards number. If you need to set up a new profile, go to the rewards section of their website to get the membership code.',
    },
    buttons: {
      primary: {
        title: 'Register Later',
      },
    },
  },
  registerBirthday: {
    pageTitle: 'Register Birthday',
    headerTitle: 'Register New Account',
    title: '{{{firstName}}}, when is your birthday?',
    instructions: 'The app will adjust to match your age.',
    buttons: {
      primary: {
        title: 'Next',
      },
      secondary: {
        title: 'Back',
      },
    },
    birthdateInput: {
      label: 'mm / dd / yyyy',
    },
  },
  registerPhoneNumber: {
    pageTitle: 'Register Phone Number',
    headerTitle: 'Register Account',
    title: {
      minor: 'What is your parent/guardians mobile number?',
      notMinor: 'What is your mobile number?',
    },
    instructions: 'We will contact you about your request.',
    buttons: {
      primary: {
        title: 'Next',
      },
      secondary: {
        title: 'Back',
      },
    },
    phoneInput: {
      label: {
        minor: 'Parent Mobile Number',
        notMinor: 'Mobile Number',
      },
      helperText: "We don't share your information with others",
      errors: {
        blank: 'Mobile Number is required',
      },
    },
    alternativePhonePrompt: {
      label: {
        minor: "Would you rather use your parent's mobile number?",
        notMinor: 'Would you rather use your mobile number?',
      },
      linkText: {
        minor: 'Parent Number',
        notMinor: 'Your Number',
      },
    },
  },

  registerEmail: {
    pageTitle: 'Register Email',
    headerTitle: 'Register New Account',
    chooseEmail: {
      email: {
        cardTitle: 'Use my personal email',
        cardBody:
          'It will be your username and cannot be used as a primary email for other accounts',
      },
      responsibleEmail: {
        cardTitle: "Use my parent/guardian's email",
        cardBody: 'You will also need to choose a username for your login',
      },
    },
    title: {
      chooseEmail: '{{{firstName}}}, set your email and username',
      email: '{{{firstName}}}, what is your personal email?',
      responsibleEmail: "{{{firstName}}}, what is your parent's email?",
    },
    instructions: {
      chooseEmail:
        'Password resets, notifications, and reward updates will be sent here.',
      email:
        "We'll send updates on your rewards and more. You can adjust these notifications in settings.",
      responsibleEmail:
        "We'll send updates on your rewards and more. Password resets will be sent here. You can adjust these notifications in settings.",
    },
    buttons: {
      swapEmail: {
        toEmail: 'USE YOUR EMAIL INSTEAD',
        toResponsibleEmail: "USE PARENT'S EMAIL INSTEAD",
      },
      primary: {
        title: 'Next',
      },
      secondary: {
        title: 'Back',
      },
    },
    emailInput: {
      label: {
        email: 'Email Address',
        responsibleEmail: "Parent's Email Address",
      },
      errors: {
        blank: 'Please enter your email.',
      },
    },
  },
  registerNames: {
    pageTitle: 'Register Names',
    headerTitle: 'Register New Account',
    title: 'Who is this account for?',
    buttons: {
      primary: {
        title: 'Next',
      },
      secondary: {
        title: 'Back',
      },
    },
    firstnameInput: {
      label: 'First Name',
      errors: {
        blank: 'Please enter your first name.',
      },
    },
    lastnameInput: {
      label: 'Last Name',
      errors: {
        blank: 'Please enter your last name.',
      },
    },
  },
  registerPassword: {
    pageTitle: 'Create Password',
    headerTitle: 'Register New Account',
    title: 'Create a Password',
    instructions: 'Your password must be a minimum of 8 characters.',
    buttons: {
      primary: {
        title: 'Next',
      },
    },
    passwordInput: {
      label: 'Password',
    },
    rememberMeCheckbox: {
      label: 'Keep me signed in',
    },
  },

  registerUsername: {
    pageTitle: 'Register Username',
    headerTitle: 'Register New Account',
    title: '{{{firstName}}}, choose a username for your account login',
    instructions:
      "Add a username or use our suggestion. You can use letters, numbers & periods. Don't worry, you can change it at any time.",
    buttons: {
      primary: {
        title: 'Next',
      },
    },
    usernameInput: {
      label: 'Username',
    },
  },
  registrationMethods: {
    pageTitle: 'Register Account',
    headerTitle: 'Register New Account',
    title: 'Register now and start earning points!',
    instructions: {
      base: '{{ registrationMethod }} {{ readyToRegisterText }}',
      registrationMethod: {
        businessCode: '',
        validCardNumber: 'We found that rewards number.',
        invalidCardNumber: 'We found that temporary registration code.',
        inviteCode: '',
      },
      readyToRegisterText: {
        linkedPractice:
          'Register your account with the {{{ linkedPracticeName }}} rewards program to participate and earn points towards awesome prizes!',
        default: 'You are ready to register',
      },
    },
    dividerText: 'or',
    socialLogin: {
      facebook: {
        label: 'Facebook',
      },
      google: {
        label: 'Google',
      },
      apple: {
        label: 'Apple',
      },
    },
    continueWithEmailButton: {
      title: 'Continue With Email',
    },
  },
  registrationSuccess: {
    pageTitle: 'Registration Success',
    headerTitle: 'Register New Account',
    title: 'Success!',
    instructions: {
      base: '{{{ firstName }}}, your username to log in is {{#primaryColor}}{{#bold}}{{{ username }}}{{/bold}}{{/primaryColor}}.',
      defaultUserName: 'Congrats',
    },
    buttons: {
      primary: {
        title: 'Go To My Account',
      },
    },
  },
  socialAlreadyRegistered: {
    pageTitle: 'Already Registered',
    headerTitle: 'Welcome Back',
    title: "It looks like you're already registered",
    defaultMessage:
      'You previously registered with a social platform. Click the button below to log in.',
  },
  general: {
    redirectErrorMessage:
      'Error logging in.  Please try re-entering your credentials.',
    lostProgressWarning:
      'Are you sure you want to leave? Progress will be lost.',
    validation: {
      tooManyRequests:
        'Too many requests, please wait for a minute and try again.',
    },
    noRegistrationDataError:
      "No registration data was found. This usually means the user has finished registration and needs to be informed they've already registered, but no token was given to look up such user.",
    registrationError: {
      emailAlreadyInUse:
        "That email is already in use. Choose a different personal email or use your parent's email instead.",
      message:
        'An error has occurred in the registration process: {{{ detailedError }}}.',
      failedConnectingRewardsCard:
        'Failed connecting a rewards card to the user',
      failedConnectingInvite: 'Failed connecting an invite code to the user',
      failedConnectingBusinessCode:
        'Failed connecting a business code to the user',
      failedConnectingVerifyingEmail:
        'Failed connecting verifying the email of the user',
      unableToCheckRegistrationStatus:
        "Unable to check user's registration status",
      unableToCommitRewardsCard: 'Unable to commit rewards card to user',
      unableToCommitInviteCode: 'Unable to commit invite code to user',
      failedUpdatingUserRegistrationInfo:
        "Failed updating user's registration information",
      failedConnectingSocialPlatform: 'Error connecting with {{{ platform }}}.',
    },
  },
};
